import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const EmailTemplateList = Loadable(lazy(() => import("features/EmailTemplate/components/List")));
const EmailTemplatePage = Loadable(lazy(() => import("features/EmailTemplate/components/Page")));

const routes = {
  path: "emailTemplate",
  children: [
    { path: "", element: <EmailTemplateList /> },
    { path: "add", element: <EmailTemplatePage /> },
    { path: "edit/:id?", element: <EmailTemplatePage /> },
  ],
};

export default routes;
